import React from "react";
import { PageTitle, PromoPlacard } from "../../components";
import { TOC } from "../../components/Toc/_.styled";
import { ColumnLayout } from "./_.styled";

const TocTemplate = ({ cdhTopicHierarchy, title, placard, cdh }) => {
  return (
    <>
      <PageTitle>{title}</PageTitle>
      <ColumnLayout>
        <div className="column">
          <TOC hierarchy={cdh} topLevelCategory={cdhTopicHierarchy} />
        </div>
        {placard && (
          <div className="column">
            <PromoPlacard
              description={placard.description}
              imgAlt={placard.imgAlt}
              imgSrc={placard.imgSrc}
              title={placard.title}
              url={placard.url}
              urlText={placard.urlText}
              telemetryData={placard.telemetryData}
            />
          </div>
        )}
      </ColumnLayout>
    </>
  );
};

export default TocTemplate;
